import { a as rem, i as _responsive, n as _getArrayProp } from "./helpers-bwfx1e-Y.js";
import { t as getTheme_v2 } from "./getTheme_v2-y09KqtEb.js";
import { y as Box } from "./useLayer-BAVfmbNN.js";
import { c } from "react/compiler-runtime";
import { styled } from "styled-components";
import { jsx } from "react/jsx-runtime";
const GRID_CSS = {
	"&&:not([hidden])": { display: "grid" },
	"&[data-as=\"ul\"],&[data-as=\"ol\"]": { listStyle: "none" }
}, GRID_AUTO_COLUMS = {
	auto: "auto",
	min: "min-content",
	max: "max-content",
	fr: "minmax(0, 1fr)"
}, GRID_AUTO_ROWS = {
	auto: "auto",
	min: "min-content",
	max: "max-content",
	fr: "minmax(0, 1fr)"
};
function responsiveGridStyle() {
	return [
		GRID_CSS,
		responsiveGridAutoFlowStyle,
		responsiveGridAutoRowsStyle,
		responsiveGridAutoColsStyle,
		responsiveGridColumnsStyle,
		responsiveGridRowsStyle,
		responsiveGridGapStyle,
		responsiveGridGapXStyle,
		responsiveGridGapYStyle
	];
}
function responsiveGridAutoFlowStyle(props) {
	let { media } = getTheme_v2(props.theme);
	return _responsive(media, props.$autoFlow, (autoFlow) => ({ gridAutoFlow: autoFlow }));
}
function responsiveGridAutoRowsStyle(props) {
	let { media } = getTheme_v2(props.theme);
	return _responsive(media, props.$autoRows, (autoRows) => ({ gridAutoRows: autoRows && GRID_AUTO_ROWS[autoRows] }));
}
function responsiveGridAutoColsStyle(props) {
	let { media } = getTheme_v2(props.theme);
	return _responsive(media, props.$autoCols, (autoCols) => ({ gridAutoColumns: autoCols && GRID_AUTO_COLUMS[autoCols] }));
}
function responsiveGridColumnsStyle(props) {
	let { media } = getTheme_v2(props.theme);
	return _responsive(media, props.$columns, (columns) => ({ gridTemplateColumns: columns && `repeat(${columns},minmax(0,1fr));` }));
}
function responsiveGridRowsStyle(props) {
	let { media } = getTheme_v2(props.theme);
	return _responsive(media, props.$rows, (rows) => ({ gridTemplateRows: rows && `repeat(${rows},minmax(0,1fr));` }));
}
function responsiveGridGapStyle(props) {
	let { media, space } = getTheme_v2(props.theme);
	return _responsive(media, props.$gap, (gap) => ({ gridGap: gap ? rem(space[gap]) : void 0 }));
}
function responsiveGridGapXStyle(props) {
	let { media, space } = getTheme_v2(props.theme);
	return _responsive(media, props.$gapX, (gapX) => ({ columnGap: gapX ? rem(space[gapX]) : void 0 }));
}
function responsiveGridGapYStyle(props) {
	let { media, space } = getTheme_v2(props.theme);
	return _responsive(media, props.$gapY, (gapY) => ({ rowGap: gapY ? rem(space[gapY]) : void 0 }));
}
const StyledGrid = /* @__PURE__ */ styled(Box).withConfig({
	displayName: "StyledGrid",
	componentId: "sc-07m1xn-0"
})(responsiveGridStyle);
function GridComponent(props) {
	let $ = c(43), as, autoCols, autoFlow, autoRows, children, gap, gapX, gapY, gridTemplateColumns, gridTemplateRows, ref, restProps;
	$[0] === props ? (as = $[1], autoCols = $[2], autoFlow = $[3], autoRows = $[4], children = $[5], gap = $[6], gapX = $[7], gapY = $[8], gridTemplateColumns = $[9], gridTemplateRows = $[10], ref = $[11], restProps = $[12]) : ({as, autoRows, autoCols, autoFlow, gridTemplateColumns, gap, gapX, gapY, gridTemplateRows, children, ref, ...restProps} = props, $[0] = props, $[1] = as, $[2] = autoCols, $[3] = autoFlow, $[4] = autoRows, $[5] = children, $[6] = gap, $[7] = gapX, $[8] = gapY, $[9] = gridTemplateColumns, $[10] = gridTemplateRows, $[11] = ref, $[12] = restProps);
	let t0 = typeof as == "string" ? as : void 0, t1;
	$[13] === autoRows ? t1 = $[14] : (t1 = _getArrayProp(autoRows), $[13] = autoRows, $[14] = t1);
	let t2;
	$[15] === autoCols ? t2 = $[16] : (t2 = _getArrayProp(autoCols), $[15] = autoCols, $[16] = t2);
	let t3;
	$[17] === autoFlow ? t3 = $[18] : (t3 = _getArrayProp(autoFlow), $[17] = autoFlow, $[18] = t3);
	let t4;
	$[19] === gridTemplateColumns ? t4 = $[20] : (t4 = _getArrayProp(gridTemplateColumns), $[19] = gridTemplateColumns, $[20] = t4);
	let t5;
	$[21] === gap ? t5 = $[22] : (t5 = _getArrayProp(gap), $[21] = gap, $[22] = t5);
	let t6;
	$[23] === gapX ? t6 = $[24] : (t6 = _getArrayProp(gapX), $[23] = gapX, $[24] = t6);
	let t7;
	$[25] === gapY ? t7 = $[26] : (t7 = _getArrayProp(gapY), $[25] = gapY, $[26] = t7);
	let t8;
	$[27] === gridTemplateRows ? t8 = $[28] : (t8 = _getArrayProp(gridTemplateRows), $[27] = gridTemplateRows, $[28] = t8);
	let t9;
	return $[29] !== as || $[30] !== children || $[31] !== ref || $[32] !== restProps || $[33] !== t0 || $[34] !== t1 || $[35] !== t2 || $[36] !== t3 || $[37] !== t4 || $[38] !== t5 || $[39] !== t6 || $[40] !== t7 || $[41] !== t8 ? (t9 = /* @__PURE__ */ jsx(StyledGrid, {
		"data-as": t0,
		"data-ui": "Grid",
		...restProps,
		$autoRows: t1,
		$autoCols: t2,
		$autoFlow: t3,
		$columns: t4,
		$gap: t5,
		$gapX: t6,
		$gapY: t7,
		$rows: t8,
		forwardedAs: as,
		ref,
		children
	}), $[29] = as, $[30] = children, $[31] = ref, $[32] = restProps, $[33] = t0, $[34] = t1, $[35] = t2, $[36] = t3, $[37] = t4, $[38] = t5, $[39] = t6, $[40] = t7, $[41] = t8, $[42] = t9) : t9 = $[42], t9;
}
/**
* The `Grid` component is for building 2-dimensional layers (based on CSS grid).
*
* @public
*/
const Grid = GridComponent;
export { Grid as t };

//# sourceMappingURL=grid-BXHFJhf_.js.map